export default {
  // Parking search page
  'pages.search.parking.tab.all': 'All Parking',
  'pages.search.parking.tab.favorite': 'My Favorites',

  // Parking management page
  'pages.parking.title': 'Parking Management',
  'pages.parking.subTitle': 'Manage parking space information in the community',
  'pages.parking.breadcrumb.property': 'Property Management',
  'pages.parking.breadcrumb.baseData': 'Base Data',
  'pages.parking.breadcrumb.parking': 'Parking Management',

  // Parking table
  'pages.parking.table.title': 'Parking List',
  'pages.parking.table.columns.building': 'Building',
  'pages.parking.table.columns.location': 'Location',
  'pages.parking.table.columns.area': 'Area',
  'pages.parking.table.columns.parkingNumber': 'Parking Number',
  'pages.parking.table.columns.parkingType': 'Parking Type',
  'pages.parking.table.columns.parkingStatus': 'Parking Status',
  'pages.parking.table.columns.amount': 'Amount (CNY)',
  'pages.parking.table.columns.reserveAmount': 'Reserve Amount',
  'pages.parking.table.columns.bindHouse': 'Bind House',
  'pages.parking.table.columns.ownerName': 'Owner Name',
  'pages.parking.table.columns.ownerPhone': 'Owner Phone',
  'pages.parking.table.columns.remarks': 'Remarks',
  'pages.parking.table.columns.createdTime': 'Created Time',
  'pages.parking.table.columns.operations': 'Operations',
  'pages.parking.table.tab.all': 'All',
  'pages.parking.table.tab.reserved': 'Reserved',

  // Parking status
  'pages.parking.status.available': 'Available',
  'pages.parking.status.sold': 'Sold',
  'pages.parking.status.rented': 'Rented',
  'pages.parking.status.reserved': 'Reserved',
  'pages.parking.status.disabled': 'Disabled',

  // Action buttons
  'pages.parking.actions.view': 'View',
  'pages.parking.actions.sell': 'Sell',

  // Parking detail modal
  'pages.parking.detail.title': 'Parking Details',
  'pages.parking.detail.tab.detail': 'Parking Detail',
  'pages.parking.detail.tab.basic': 'Basic Info',
  'pages.parking.detail.tab.sale': 'Parking Sale',
  'pages.parking.detail.tab.rent': 'Parking Rent',
  'pages.parking.detail.tab.repayment': 'Parking Repayment',
  'pages.parking.detail.tab.managementFee': 'Parking Management Fee',
  'pages.parking.detail.tab.document': 'Related Documents',
  'pages.parking.detail.tab.operationLog': 'Operation Log',
  'pages.parking.detail.basicInfo': 'Basic Information',

  // Parking related documents
  'pages.parking.document.table.title': 'Related Documents',
  'pages.parking.document.table.columns.category': 'Document Category',
  'pages.parking.document.table.columns.fileType': 'File Type',
  'pages.parking.document.table.columns.fileSize': 'File Size',
  'pages.parking.document.table.columns.createdBy': 'Created By',
  'pages.parking.document.table.columns.createdTime': 'Created Time',
  'pages.parking.document.table.columns.remarks': 'Remarks',
  'pages.parking.document.table.columns.action': 'Action',
  'pages.parking.document.action.add': 'Add Document',
  'pages.parking.document.action.download': 'Download',
  'pages.parking.document.action.chooseFile': 'Choose File',
  'pages.parking.document.action.uploading': 'Uploading',
  'pages.parking.document.action.create': 'Add',
  'pages.parking.document.action.update': 'Update',
  'pages.parking.document.modal.createTitle': 'Add Document',
  'pages.parking.document.modal.editTitle': 'Edit Document',
  'pages.parking.document.form.category.label': 'Document Category',
  'pages.parking.document.form.category.placeholder':
    'Please select document category',
  'pages.parking.document.form.category.required':
    'Please select document category',
  'pages.parking.document.form.file.label': 'Document File',
  'pages.parking.document.form.remarks.label': 'Remarks',
  'pages.parking.document.form.remarks.placeholder': 'Please enter remarks',
  'pages.parking.document.form.remarks.maxLength':
    'Remarks cannot exceed 500 characters',
  'pages.parking.document.tip.uploaded': '✓ Uploaded: {name}',
  'pages.parking.document.message.uploadSuccess': 'File uploaded successfully',
  'pages.parking.document.message.uploadFailed': 'File upload failed',
  'pages.parking.document.message.createSuccess': 'Document added successfully',
  'pages.parking.document.message.createFailed': 'Add failed',
  'pages.parking.document.message.updateSuccess':
    'Document updated successfully',
  'pages.parking.document.message.updateFailed': 'Update failed',
  'pages.parking.document.message.deleteSuccess':
    'Document deleted successfully',
  'pages.parking.document.message.deleteFailed': 'Delete failed',
  'pages.parking.document.warning.noFilePath': 'File path does not exist',
  'pages.parking.document.error.noBizId': 'Parking ID does not exist',
  'pages.parking.document.validation.fileRequired':
    'Please upload a file first',
  'pages.parking.document.confirm.delete.title': 'Confirm Deletion',
  'pages.parking.document.confirm.delete.content':
    'Are you sure you want to delete document "{name}"?',
  'pages.parking.detail.locationInfo': 'Location Information',
  'pages.parking.detail.bindInfo': 'Binding Information',
  'pages.parking.detail.bindAppInfo': 'Bound APP Account',
  'pages.parking.detail.ownerInfo': 'Owner Information',
  'pages.parking.detail.saleInfo': 'Sale Information',
  'pages.parking.detail.rentalInfo': 'Rental Information',
  'pages.parking.detail.priceInfo': 'Price Information',
  'pages.parking.detail.systemInfo': 'System Information',

  // Parking operation log
  'pages.parking.operationLog.title': 'Operation Log',
  'pages.parking.operationLog.action.refresh': 'Refresh',
  'pages.parking.operationLog.columns.createdTime': 'Operation Time',
  'pages.parking.operationLog.columns.logType': 'Operation Type',
  'pages.parking.operationLog.columns.message': 'Operation Message',
  'pages.parking.operationLog.columns.operatorName': 'Operator',
  'pages.parking.operationLog.columns.operatorIp': 'Operator IP',

  // Detail field labels
  'pages.parking.detail.label.parkingNumber': 'Parking Number',
  'pages.parking.detail.label.parkingType': 'Parking Type',
  'pages.parking.detail.label.parkingStatus': 'Parking Status',
  'pages.parking.detail.label.building': 'Building',
  'pages.parking.detail.label.location': 'Location',
  'pages.parking.detail.label.area': 'Area',
  'pages.parking.detail.label.bindHouse': 'Bind House',
  'pages.parking.detail.label.ownerInfo': 'Owner Information',
  'pages.parking.detail.label.ownerName': 'Owner Name',
  'pages.parking.detail.label.ownerPhone': 'Owner Phone',
  'pages.parking.detail.label.appUsername': 'APP Username',
  'pages.parking.detail.label.appName': 'APP Name',
  'pages.parking.detail.label.appPhone': 'APP Phone',
  'pages.parking.detail.label.appEmail': 'APP Email',
  'pages.parking.detail.label.saleAmount': 'Sale Amount',
  'pages.parking.detail.label.discountAmount': 'Discount Amount',
  'pages.parking.detail.label.finalAmount': 'Final Amount',
  'pages.parking.detail.label.monthlyRepaymentLimit': 'Monthly Repayment Limit',
  'pages.parking.detail.label.saleTime': 'Sale Time',
  'pages.parking.detail.label.rent': 'Rent',
  'pages.parking.detail.label.rentStartTime': 'Start Time',
  'pages.parking.detail.label.rentEndTime': 'End Time',
  'pages.parking.detail.label.rentPeriod': 'Rental Period',
  'pages.parking.detail.label.parkingAmount': 'Parking Amount',
  'pages.parking.detail.label.createdTime': 'Created Time',
  'pages.parking.detail.label.updatedTime': 'Updated Time',
  'pages.parking.detail.label.remarks': 'Remarks',

  // Buttons
  'pages.parking.detail.button.close': 'Close',

  // Owner bind/unbind
  'pages.parking.owner.bind.button': 'Bind Owner',
  'pages.parking.owner.bind.success': 'Owner bound successfully',
  'pages.parking.owner.bind.failed': 'Failed to bind owner',
  'pages.parking.owner.unbind.button': 'Unbind',
  'pages.parking.owner.unbind.confirm.title': 'Confirm unbinding',
  'pages.parking.owner.unbind.confirm.content':
    'Unbinding will clear the current parking owner information. Continue?',
  'pages.parking.owner.unbind.success': 'Unbound successfully',
  'pages.parking.owner.unbind.failed': 'Failed to unbind',
  'pages.parking.owner.edit.button': 'Edit Owner Information',
  'pages.parking.owner.update.success':
    'Owner information updated successfully',
  'pages.parking.owner.update.failed': 'Failed to update owner information',
  'pages.parking.owner.form.ownerNamePlaceholder': 'Enter owner name',
  'pages.parking.owner.form.ownerPhonePlaceholder': 'Enter owner phone',
  'pages.parking.owner.select.placeholder': 'Please select an owner',
  'pages.parking.owner.select.current': 'Selected owner: ',
  'pages.parking.owner.modal.title': 'Select Owner',
  'pages.parking.owner.modal.okText': 'Bind',
  'pages.parking.owner.modal.cancelText': 'Cancel',
  'pages.parking.owner.table.select': 'Select',
  'pages.parking.owner.table.username': 'Username',
  'pages.parking.owner.table.name': 'Name',
  'pages.parking.owner.table.phone': 'Phone',
  'pages.parking.owner.table.email': 'Email',
  'pages.parking.owner.table.idCard': 'ID Card',
  'pages.parking.owner.table.status': 'Status',
  'pages.parking.owner.status.enabled': 'Active',
  'pages.parking.owner.status.disabled': 'Disabled',

  // Favorite
  'pages.parking.favorite.button.favorite': 'Favorite',
  'pages.parking.favorite.button.favorited': 'Favorited',
  'pages.parking.favorite.message.favoriteSuccess': 'Added to favorites',
  'pages.parking.favorite.message.favoriteFailed': 'Failed to add to favorites',
  'pages.parking.favorite.message.unfavoriteSuccess': 'Removed from favorites',
  'pages.parking.favorite.message.unfavoriteFailed':
    'Failed to remove from favorites',
  'pages.parking.favorite.message.actionFailed': 'Operation failed',

  // Parking selection
  'pages.parking.select.current': 'Current Selection: ',

  // Currency symbol
  'pages.parking.currency.symbol': '₱',

  // Parking structure tree
  'pages.parking.structureTree.title': 'Parking Structure',
  'pages.parking.structureTree.action.addFloor': 'Add Floor',
  'pages.parking.structureTree.confirm.deleteTitle': 'Confirm Delete',
  'pages.parking.structureTree.confirm.deleteContent':
    'Are you sure you want to delete "{name}"? All child nodes will also be deleted.',
  'pages.parking.structureTree.message.loadFailed':
    'Failed to load parking structure',
  'pages.parking.structureTree.message.deleteSuccess': 'Deleted successfully',
  'pages.parking.structureTree.message.deleteFailed': 'Delete failed',
  'pages.parking.structureTree.message.updateSuccess': 'Updated successfully',
  'pages.parking.structureTree.message.updateFailed': 'Update failed',
  'pages.parking.structureTree.message.createSuccess': 'Created successfully',
  'pages.parking.structureTree.message.createFailed': 'Create failed',
  'pages.parking.structureTree.form.editTitle': 'Edit Parking Structure',
  'pages.parking.structureTree.form.createTitle': 'Add Parking Structure',
  'pages.parking.structureTree.form.label.name': 'Name',
  'pages.parking.structureTree.form.label.sort': 'Sort',
  'pages.parking.structureTree.form.placeholder.name':
    'Please enter name, e.g. B2, Zone A',
  'pages.parking.structureTree.form.placeholder.sort':
    'Please enter sort value',
  'pages.parking.structureTree.form.validation.nameRequired':
    'Please enter name',
  'pages.parking.structureTree.form.validation.nameMaxLength':
    'Name cannot exceed 100 characters',

  // Parking form
  'pages.parking.form.editTitle': 'Edit Parking',
  'pages.parking.form.createTitle': 'New Parking',
  'pages.parking.form.basicInfo': 'Basic Information',
  'pages.parking.form.locationInfo': 'Location Information',
  'pages.parking.form.ownerInfo': 'Owner Information',
  'pages.parking.form.saleInfo': 'Sale Information',
  'pages.parking.form.rentalInfo': 'Rental Information',
  'pages.parking.form.remarksInfo': 'Remarks',
  'pages.parking.form.status.available': 'Available',
  'pages.parking.form.status.rented': 'Rented',
  'pages.parking.form.status.sold': 'Sold',
  'pages.parking.form.status.reserved': 'Reserved',
  'pages.parking.form.status.unknown': 'Unknown',

  // Form field labels
  'pages.parking.form.label.building': 'Building',
  'pages.parking.form.label.location': 'Location',
  'pages.parking.form.label.floor': 'Floor',
  'pages.parking.form.label.area': 'Area',
  'pages.parking.form.label.parkingNumber': 'Parking Number',
  'pages.parking.form.label.parkingType': 'Parking Type',
  'pages.parking.form.label.parkingStatus': 'Parking Status',
  'pages.parking.form.label.price': 'Parking Price',
  'pages.parking.form.label.ownerName': 'Owner Name',
  'pages.parking.form.label.ownerPhone': 'Owner Phone',
  'pages.parking.form.label.saleAmount': 'Sale Amount',
  'pages.parking.form.label.discountAmount': 'Discount Amount',
  'pages.parking.form.label.finalAmount': 'Final Amount',
  'pages.parking.form.label.monthlyRepaymentLimit': 'Monthly Repayment Limit',
  'pages.parking.form.label.saleTime': 'Sale Time',
  'pages.parking.form.label.rent': 'Rent',
  'pages.parking.form.label.rentStartTime': 'Lease Start Time',
  'pages.parking.form.label.rentEndTime': 'Lease End Time',
  'pages.parking.form.label.remarks': 'Remarks',
  'pages.parking.form.label.bindHouse': 'Bind House',
  'pages.parking.form.label.bindApp': 'Bind APP Account',
  'pages.parking.form.label.owner': 'Owner',

  // Form placeholders
  'pages.parking.form.placeholder.building': 'Please select building',
  'pages.parking.form.placeholder.location': 'Please select location',
  'pages.parking.form.placeholder.houseId': 'Please select house',
  'pages.parking.form.placeholder.floor': 'Please select floor',
  'pages.parking.form.placeholder.area': 'Please select area',
  'pages.parking.form.placeholder.parkingNumber': 'Please enter parking number',
  'pages.parking.form.placeholder.parkingType': 'Please select parking type',
  'pages.parking.form.placeholder.parkingStatus':
    'Please select parking status',
  'pages.parking.form.placeholder.price': 'Please enter parking price',
  'pages.parking.form.placeholder.ownerName': 'Please enter owner name',
  'pages.parking.form.placeholder.ownerPhone': 'Please enter owner phone',
  'pages.parking.form.placeholder.bindApp':
    'Please search and select APP user to bind',
  'pages.parking.form.placeholder.selectOwner': 'Please select owner',
  'pages.parking.form.placeholder.bindHouse': 'Please select related house',
  'pages.parking.form.placeholder.saleAmount': 'Please enter sale amount',
  'pages.parking.form.placeholder.discountAmount':
    'Please enter discount amount',
  'pages.parking.form.placeholder.finalAmount': 'Auto calculated',
  'pages.parking.form.placeholder.monthlyRepaymentLimit':
    'Please enter monthly repayment limit',
  'pages.parking.form.placeholder.saleTime': 'Please select sale time',
  'pages.parking.form.placeholder.rent': 'Please enter rent',
  'pages.parking.form.placeholder.rentStartTime':
    'Please select lease start time',
  'pages.parking.form.placeholder.rentEndTime': 'Please select lease end time',
  'pages.parking.form.placeholder.remarks': 'Please enter remarks',

  // Form validation messages
  'pages.parking.form.validation.buildingRequired': 'Please select building',
  'pages.parking.form.validation.locationRequired': 'Please select location',
  'pages.parking.form.validation.floorRequired': 'Please select floor',
  'pages.parking.form.validation.areaRequired': 'Please select area',
  'pages.parking.form.validation.parkingNumberRequired':
    'Please enter parking number',
  'pages.parking.form.validation.parkingNumberMaxLength':
    'Parking number cannot exceed 50 characters',
  'pages.parking.form.validation.parkingTypeRequired':
    'Please select parking type',
  'pages.parking.form.validation.parkingStatusRequired':
    'Please select parking status',
  'pages.parking.form.validation.priceRequired': 'Please enter parking price',
  'pages.parking.form.validation.priceMin': 'Parking price cannot be negative',
  'pages.parking.form.validation.saleAmountRequired':
    'Please enter sale amount',
  'pages.parking.form.validation.saleAmountMin':
    'Sale amount cannot be negative',
  'pages.parking.form.validation.discountAmountMin':
    'Discount amount cannot be negative',
  'pages.parking.form.validation.finalAmountRequired':
    'Please enter final amount',
  'pages.parking.form.validation.finalAmountMin':
    'Final amount cannot be negative',
  'pages.parking.form.validation.monthlyRepaymentLimitMin':
    'Monthly repayment limit cannot be negative',
  'pages.parking.form.validation.saleTimeRequired': 'Please select sale time',
  'pages.parking.form.validation.rentRequired': 'Please enter rent',
  'pages.parking.form.validation.rentMin': 'Rent cannot be negative',
  'pages.parking.form.validation.rentStartTimeRequired':
    'Please select lease start time',
  'pages.parking.form.validation.rentEndTimeRequired':
    'Please select lease end time',
  'pages.parking.form.validation.remarksMaxLength':
    'Remarks cannot exceed 500 characters',

  // Form buttons
  'pages.parking.form.button.ownerSearch': 'Search',
  'pages.parking.form.button.ownerClear': 'Clear',
  'pages.parking.form.action.cancelSale': 'Cancel Sale',

  // Success/Failure messages
  'pages.parking.form.message.updateSuccess': 'Update successful',
  'pages.parking.form.message.createSuccess': 'Create successful',
  'pages.parking.form.message.updateFailed': 'Update failed',
  'pages.parking.form.message.createFailed': 'Create failed',
  'pages.parking.form.message.loadParkingTypeFailed':
    'Failed to get parking type dictionary, please contact administrator',
  'pages.parking.form.message.loadParkingTypeError':
    'Failed to load parking type dictionary, please contact administrator',
  'pages.parking.form.message.loadParkingStatusFailed':
    'Failed to get parking status dictionary, please contact administrator',
  'pages.parking.form.message.loadParkingStatusError':
    'Failed to load parking status dictionary, please contact administrator',

  // House selector
  'pages.parking.houseSelector.title': 'Select House',
  'pages.parking.houseSelector.okText': 'Confirm Selection',
  'pages.parking.houseSelector.cancelText': 'Cancel',

  // House table columns
  'pages.parking.houseSelector.table.buildingName': 'Building Name',
  'pages.parking.houseSelector.table.floor': 'Floor',
  'pages.parking.houseSelector.table.houseNumber': 'House Number',
  'pages.parking.houseSelector.table.ownerName': 'Owner Name',
  'pages.parking.houseSelector.table.ownerPhone': 'Owner Phone',
  'pages.parking.houseSelector.table.status': 'Status',
  'pages.parking.houseSelector.table.operations': 'Operations',

  // Dividers
  'pages.parking.form.divider.locationInfo': 'Location Information',
  'pages.parking.form.divider.basicInfo': 'Basic Information',
  'pages.parking.form.divider.bindInfo': 'Binding Information',
  'pages.parking.form.divider.saleInfo': 'Sale Information',
  'pages.parking.form.divider.rentalInfo': 'Rental Information',
  'pages.parking.form.divider.remarksInfo': 'Remarks',

  // Form field labels
  'pages.parking.form.label.houseId': 'House ID',
  'pages.parking.form.label.selectOwner': 'Select Owner',

  // Parking form tabs
  'pages.parking.form.tab.basic': 'Basic Info',
  'pages.parking.form.tab.reserved': 'Parking Reservation',
  'pages.parking.form.tab.sold': 'Parking Sale',
  'pages.parking.form.tab.rented': 'Parking Rental',
  'pages.parking.form.tab.finance': 'Financial Registration',
  'pages.parking.form.tab.repayment': 'Parking Repayment',
  'pages.parking.form.tab.document': 'Related Documents',
  'pages.parking.form.tab.operationLog': 'Operation Log',

  // Parking form buttons
  'pages.parking.form.button.cancelReservation': 'Cancel Reservation',
  'pages.parking.form.button.cancelSale': 'Cancel Sale',
  'pages.parking.form.button.cancelRent': 'Cancel Rental',

  // Parking form - reservation
  'pages.parking.form.reserved.section.info': 'Reservation Information',
  'pages.parking.form.reserved.section.agentInfo': 'Agent Information',
  'pages.parking.form.reserved.label.reserveUserName': 'Reserved By',
  'pages.parking.form.reserved.label.reserveUserPhone': 'Reserved User Phone',
  'pages.parking.form.reserved.label.reserveUserEmail': 'Reserved User Email',
  'pages.parking.form.reserved.label.reserveTime': 'Reservation Time',
  'pages.parking.form.reserved.label.reserveAgentId': 'Parking Agent',
  'pages.parking.form.reserved.label.agentCompany': 'Agent Company',
  'pages.parking.form.reserved.placeholder.reserveUserName':
    'Please enter reserved user name',
  'pages.parking.form.reserved.placeholder.reserveUserPhone':
    'Please enter reserved user phone',
  'pages.parking.form.reserved.placeholder.reserveUserEmail':
    'Please enter reserved user email',
  'pages.parking.form.reserved.placeholder.reserveTime':
    'Please select reservation time',
  'pages.parking.form.reserved.placeholder.reserveAgentId':
    'Please select parking agent',
  'pages.parking.form.reserved.validation.reserveUserNameMax':
    'Reserved user name cannot exceed 50 characters',
  'pages.parking.form.reserved.validation.reserveUserEmailPattern':
    'Please enter a valid email address',

  // Parking form - sale
  'pages.parking.form.sold.section.saleAmount': 'Sale Amount',
  'pages.parking.form.sold.section.saleInfo': 'Sale Information',
  'pages.parking.form.sold.section.repaymentConfig': 'Repayment Configuration',
  'pages.parking.form.sold.label.price': 'Sale Price',
  'pages.parking.form.sold.label.area': 'Parking Area',
  'pages.parking.form.sold.label.areaPrefix': 'Area',
  'pages.parking.form.sold.label.editArea': 'Edit Area',
  'pages.parking.form.sold.label.discountAmount': 'Discount Amount',
  'pages.parking.form.sold.label.finalAmount': 'Final Price',
  'pages.parking.form.sold.label.soldType': 'Sale Type',
  'pages.parking.form.sold.label.mortgageTimeRange': 'Mortgage Repayment Time',
  'pages.parking.form.sold.placeholder.price': 'Please enter sale price',
  'pages.parking.form.sold.placeholder.area': 'Please enter parking area',
  'pages.parking.form.sold.placeholder.discountAmount':
    'Please enter discount amount',
  'pages.parking.form.sold.placeholder.finalAmount': 'Please enter final price',
  'pages.parking.form.sold.placeholder.soldType': 'Please select sale type',
  'pages.parking.form.sold.placeholder.mortgageStartMonth': 'Start month',
  'pages.parking.form.sold.placeholder.mortgageEndMonth': 'End month',
  'pages.parking.form.sold.option.soldType.loan': 'Loan',
  'pages.parking.form.sold.option.soldType.fullPayment': 'Full Payment',
  'pages.parking.form.sold.validation.priceMin':
    'Sale price cannot be negative',
  'pages.parking.form.sold.validation.areaMin':
    'Parking area cannot be negative',
  'pages.parking.form.sold.validation.discountAmountMin':
    'Discount amount cannot be negative',
  'pages.parking.form.sold.validation.finalAmountMin':
    'Final price cannot be negative',
  'pages.parking.form.sold.validation.soldTypeRequired':
    'Please select sale type',

  // Parking form - owner selector
  'pages.parking.form.owner.modal.title': 'Select Owner',
  'pages.parking.form.owner.table.idCard': 'ID Card Number',
  'pages.parking.form.owner.status.enabled': 'Enabled',
  'pages.parking.form.owner.status.disabled': 'Disabled',

  // Parking finance registration
  'pages.parking.finance.table.title': 'Financial Registration Records',
  'pages.parking.finance.button.newRecord': 'New Registration',
  'pages.parking.finance.loading': 'Loading...',
  'pages.parking.finance.table.column.applyTime': 'Application Time',
  'pages.parking.finance.table.column.feeType': 'Fee Type',
  'pages.parking.finance.table.column.amount': 'Amount',
  'pages.parking.finance.table.column.status': 'Status',
  'pages.parking.finance.table.column.applicant': 'Applicant',
  'pages.parking.finance.table.column.remarks': 'Remarks',
  'pages.parking.finance.status.pending': 'Pending',
  'pages.parking.finance.status.approved': 'Paid',
  'pages.parking.finance.status.rejected': 'Cancelled',

  // Common action keys
  'common.action.create': 'Create',
  'common.action.edit': 'Edit',
  'common.action.delete': 'Delete',
  'common.action.confirm': 'Confirm',
  'common.action.cancel': 'Cancel',
  'common.action.deselect': 'Deselect',
  'common.action.batchDelete': 'Batch Delete',
  'common.label.selected': 'Selected',
  'common.label.items': 'items',
  'common.confirm.delete': 'Are you sure you want to delete this record?',
  'common.confirm.batchDelete':
    'Are you sure you want to batch delete the selected records?',

  // Parking finance record modal
  'pages.parking.financeModal.title.create': 'Create Financial Record',
  'pages.parking.financeModal.label.parkingInfo': 'Parking Info',
  'pages.parking.financeModal.label.amountType': 'Amount Type',
  'pages.parking.financeModal.label.amount': 'Amount',
  'pages.parking.financeModal.label.bankStatement': 'Bank Statement',
  'pages.parking.financeModal.label.remarks': 'Remarks',
  'pages.parking.financeModal.placeholder.amountType':
    'Please select amount type',
  'pages.parking.financeModal.placeholder.feeType': 'Please select fee type',
  'pages.parking.financeModal.placeholder.amount': 'Please enter amount',
  'pages.parking.financeModal.placeholder.bankStatement':
    'Please enter keywords to search bank statements',
  'pages.parking.financeModal.placeholder.remarks': 'Please enter remarks',
  'pages.parking.financeModal.validation.amountTypeRequired':
    'Please select amount type',
  'pages.parking.financeModal.validation.feeTypeRequired':
    'Please select fee type',
  'pages.parking.financeModal.validation.amountRequired': 'Please enter amount',
  'pages.parking.financeModal.validation.bankStatementRequired':
    'Please select bank statement',
  'pages.parking.financeModal.amountType.income': 'Income',
  'pages.parking.financeModal.amountType.expense': 'Expense',
  'pages.parking.financeModal.dictLabel.realEstateFeeType':
    'Real Estate Fee Type',
  'pages.parking.financeModal.message.parkingIdMissing':
    'Parking ID does not exist',
  'pages.parking.financeModal.message.createSuccess':
    'Financial record created successfully',
  'pages.parking.financeModal.message.createFailed':
    'Failed to create financial record',
  'pages.parking.financeModal.message.createFailedRetry':
    'Failed to create financial record, please try again later',
};
